import { render, staticRenderFns } from "./workorderDca.vue?vue&type=template&id=31c3d948&"
import script from "./workorderDca.vue?vue&type=script&lang=js&"
export * from "./workorderDca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports